'use client';

import { WORLD_PICKLEBALL_RANKINGS } from '@/modules/rankings/constants';
import { DonutChartProgress } from '@/modules/rankings/ppr/player-profile/DonutChartProgress';
import { ProgressCard } from '@/modules/rankings/ppr/player-profile/ProgressCard';
import { RankingPlayerProfileData } from '@/modules/rankings/ppr/types';

interface WorldPickleballRankingProps {
  playerProfileData: RankingPlayerProfileData;
}

export function WorldPickleballRanking({ playerProfileData }: WorldPickleballRankingProps) {
  return (
    <>
      <div className='bg-white rounded-xl p-8 mb-6 flex flex-row items-center'>
        <div className='w-full h-64 flex justify-center items-center scale-[0.75] sm:scale-[0.9] md:scale-100'>
          <DonutChartProgress
            totalPoints={Math.round(playerProfileData.pprPointsTotal)}
            doublesPoints={Math.round(playerProfileData.pprPointsDoublesCalculated)}
            mixedPoints={Math.round(playerProfileData.pprPointsMixedCalculated)}
            singlesPoints={Math.round(playerProfileData.pprPointsSinglesCalculated)}
          />
        </div>
      </div>
      <div className='grid grid-row-2 bg-white rounded-lg text-center border border-gray-100'>
        <div className='flex flex-col border-b border-gray-300 p-2'>
          <div className='md:text-base text-sm text-gray-600'>{`${WORLD_PICKLEBALL_RANKINGS} Rank`}</div>
          <div className='md:text-lg text-base text-gray-900 font-semibold'>
            {playerProfileData.pprRank}
          </div>
        </div>
        <div className='flex flex-col p-2'>
          <div className='md:text-base text-sm text-gray-600'>{`${WORLD_PICKLEBALL_RANKINGS} Points`}</div>
          <div className='md:text-lg text-base text-gray-900 font-semibold'>
            {Math.round(playerProfileData.pprPointsTotal)}
          </div>
        </div>
      </div>
      <div className='grid grid-cols-1 gap-4 mt-4'>
        <ProgressCard
          title='Doubles'
          points={Math.round(playerProfileData.pprPointsDoublesCalculated).toString()}
          percentage={50}
          total={Math.round(playerProfileData.pprPointsDoublesTotal)}
          color='#4C1D95'
        />
        <ProgressCard
          title='Mixed'
          points={Math.round(playerProfileData.pprPointsMixedCalculated).toString()}
          percentage={35}
          total={Math.round(playerProfileData.pprPointsMixedTotal)}
        />
        <ProgressCard
          title='Singles'
          points={Math.round(playerProfileData.pprPointsSinglesCalculated).toString()}
          percentage={15}
          total={Math.round(playerProfileData.pprPointsSinglesTotal)}
          color='#C4B5FD'
        />
      </div>
    </>
  );
}
